
// Wire tweak scenario to dynamics scenario (runs after main.js side effects).
window.addEventListener('DOMContentLoaded', () => {
  document.getElementById('tweak-scenario')?.addEventListener('change', (e) => {
    window.Dynamics?.setScenario(e.target.value);
    document.querySelectorAll('[data-scenario]').forEach(b => b.classList.toggle('active', b.dataset.scenario === e.target.value));
  });
});
